declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, GuardianInfoRequest, SaveGuardianInfoRequest, SavePatientInfoRequest, SaveNewEnquiryRequest, GenericProcPostRequest, S_Methods, PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController } from '../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../models/master/mastermodel';
import { FDService } from '../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngbaddnewenquiry',
  templateUrl: './addnewenquiry.modal.html',
  styleUrls: ['./addnewenquiry.modal.scss']
})

export class NgbAddNewEnquiry implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() CurrentActorEditGuardianInfoRequest: SaveGuardianInfoRequest;
  @Input() ServiceCode: number;
  @Input() ActorCode: number;
  searchTitle: string;
  DateOfBirth: NgbDateStruct;
  public DateOfBirthNew: Date;
  public FDateOfBirthNew: Date;
  public isvisible: boolean = true;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  WeddingAn: NgbDateStruct;
  DateOfBirthFemale: NgbDateStruct;
  DateOfBirthMale: NgbDateStruct;
  FemaleDateofBirth: NgbDateStruct;
  public ApiResData: ApiResponseModel;
  public Age: number;
  public FemaleAge: number;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public Individual: boolean = false;
  public Donor: boolean = false;
  public Couple: boolean = false;
  public Categories: boolean = true;
  //public LoginCountry: string;
  //public LoginState: string;
  //public LoginCity: string;
  CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  //CurrentActorEditGuardainInfoRequest: GuardianInfoRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService) { }
  ngOnInit() {

    this.ShowService = false;
    //if (this.DateOfBirth != null) {
    //  var SValidFrom = new Date(this.DateOfBirthNew);
    //  if (SValidFrom.getFullYear() > 1900) {
    //    console.log('this.ActivityDate >1990');
    //    this.DateOfBirth = {
    //      year: now.setFullYear(now.getFullYear() - this.Age),
    //      month: SValidFrom.getMonth() + 1,
    //      day: SValidFrom.getDate()
    //    }
    //  }
    //}
    this.CurrentSavePatientInfoRequest = new SavePatientInfoRequest();
    this.CurrentSavePatientInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadRegistries();

  }

  individual1() {
    this.ShowService = true;
    this.Categories = false;
    this.Individual = true;
    this.Donor = false;
    this.Couple = false;
  }
  donor() {
    this.ShowService = true;
    this.Categories = false;
    this.Individual = false;
    this.Donor = true;
    this.Couple = false;
  }
  couple() {
    this.ShowService = true;
    this.Individual = false;
    this.Categories = false;
    this.Donor = false;
    this.Couple = true;
  }
  backtolist() {
    this.ShowService = true;
    this.Categories = true;
    this.Individual = false;
    this.Donor = false;
    this.Couple = false;
  }

  //BranchMapData: ServiceBranchMapByServiceCodeController[];
  //BranchMapRequest: ServiceBranchMapByServiceCodeRequest;
  //this.pdata = this.CurrentCustomCodeValuesController;
  LoadRegistries() {
    this.stopRefreshing();

    this.CurrentSaveNewEnquiryRequest = new SaveNewEnquiryRequest();
    this.CurrentSaveNewEnquiryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }

  CurrentSaveNewEnquiryRequest = new SaveNewEnquiryRequest();
  AddIndiEnquiry() {
    var saveReq = new SaveNewEnquiryRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 30070;
    saveReq.ActorCode = 0;
    saveReq.Salutation = this.CurrentSaveNewEnquiryRequest.Salutation;
    saveReq.DisplayName = this.CurrentSaveNewEnquiryRequest.DisplayName;
    saveReq.Telephone1 = this.CurrentSaveNewEnquiryRequest.Telephone1;
    saveReq.PartnerName = this.CurrentSaveNewEnquiryRequest.PartnerName;
    saveReq.Gender = this.CurrentSaveNewEnquiryRequest.Gender;
    saveReq.AddressLine1 = this.CurrentSaveNewEnquiryRequest.AddressLine1;
    saveReq.AddressLine2 = this.CurrentSaveNewEnquiryRequest.AddressLine2;
    saveReq.DateOfBirth = this.IndividualDateOfBirthNew;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.AddressCode = 0;
    saveReq.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    saveReq.ActorType = 33;
    saveReq.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;

    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 30070;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  onSubmit() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 110;
    this.CurrentSavePatientInfoRequest.DateOfBirth = this.IndividualDateOfBirthNew;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.ActorType = 33;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    this.CurrentSavePatientInfoRequest.DonorTypeName = 'NONE';
    //this.CurrentSavePatientInfoRequest.County = AppData.Instance().cas.LoginCountry;
    //this.CurrentSavePatientInfoRequest.State = AppData.Instance().cas.LoginState;
    //this.CurrentSavePatientInfoRequest.City = AppData.Instance().cas.LoginCity;

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData);
          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully, redirecting.....!');
                    this.isvisible = false;
        this.spinner.hide();
        this.activeModal.close();
            this.gotoActivityMonitoring(this.ApiResData.Result);
           
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
              this.activeModal.close();
              this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
            this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
              this.activeModal.close();
              this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
              this.activeModal.close();
              this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  //gotoActivityMonitoring(aCode: number) {
  //  var req: PatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    

  //  this.actorservice.GetPatientInfoByFormattedCodeController(req)
  //    .subscribe((res2) => {



  //      this.router.navigate(['healins/activitymonitoring', {
  //        FormattedCode: this.ApiResData.Result.ActorCode,
  //        ActorCode: this.ApiResData.Result.FormattedCode
  //      }]);

  //      this.stopRefreshing();

  //    }
          
  //}
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatient: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
  gotoActivityMonitoring(aCode: number) {
  //GetPatientInfoByFormattedCodeController(FormattedCode: number) {
    this.StartRefreshing();
    this.CurrentPatientInfoByFormattedCodeRequest.ActorCode = aCode;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 101;
    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    //alert(this.FormattedCode);
    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          this.router.navigate(['healins/activitymonitoring2', {
            FormattedCode: this.SelectedPatient.FormattedCode,
            ActorCode: this.SelectedPatient.ActorCode
        }]);

        this.stopRefreshing();
         

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  onDonor() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 110;
    this.CurrentSavePatientInfoRequest.DateOfBirth = this.DonorDateOfBirthNew;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.ActorType = 33;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    //this.CurrentSavePatientInfoRequest.DonorTypeName = 'NONE';
    //this.CurrentSavePatientInfoRequest.County = AppData.Instance().cas.LoginCountry;
    //this.CurrentSavePatientInfoRequest.State = AppData.Instance().cas.LoginState;
    //this.CurrentSavePatientInfoRequest.City = AppData.Instance().cas.LoginCity;

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData);
          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully, redirecting.....!');
            this.isvisible = false;
            this.spinner.hide();
            this.activeModal.close();
            this.gotoActivityMonitoring(this.ApiResData.Result);

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();
            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  onDonor_() {
    this.spinner.show();
    //this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 110;
    this.CurrentSavePatientInfoRequest.DateOfBirth = this.DonorDateOfBirthNew;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorType = 33;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    //this.CurrentSavePatientInfoRequest.AddressCode = 0;
    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.isvisible = false;
            this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  onCouple() {
    this.spinner.show();
    //this.CurrentSavePatientInfoRequest.WeddingAnniversary = new Date(this.parserFormatter.format(this.WeddingAn));
    this.CurrentSavePatientInfoRequest.DateOfBirth = this.DateOfBirthNew;
    this.CurrentSavePatientInfoRequest.FemaleDateofBirth = this.FDateOfBirthNew;
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 120;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorType = 33;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    this.CurrentSavePatientInfoRequest.DonorTypeName = 'NONE';
    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            this.spinner.hide();
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.isvisible = false;
            this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }

  NewAge(event: any) {

    if (event != null) {
      var temp = new Date();
      temp.setFullYear(temp.getFullYear() - this.Age);
      //this.DateOfBirth = {
      //  year: this.now.setFullYear(this.now.getFullYear() - this.Age),
      //  month: this.now.getMonth() + 1,
      //  day: this.now.getDate()
      //}
      //temp = new Date(this.parserFormatter.format(this.DateOfBirth));
      this.DateOfBirthNew = temp;
      //alert(this.DateOfBirthNew)
    }

  }
  FNewAge(event: any) {

    if (event != null) {
      var Ftemp = new Date();
      Ftemp.setFullYear(Ftemp.getFullYear() - this.FemaleAge);
      this.FDateOfBirthNew = Ftemp;
    }

  }
  public IndividualAge: number;
  public IndividualDateOfBirthNew: Date;
  IndiNewAge(event: any) {

    if (event != null) {
      var Inditemp = new Date();
      Inditemp.setFullYear(Inditemp.getFullYear() - this.IndividualAge);
      this.IndividualDateOfBirthNew = Inditemp;
    }

  }
  public DonorAge: number;
  public DonorDateOfBirthNew: Date;
  DnrNewAge(event: any) {

    if (event != null) {
      var Dnrtemp = new Date();
      Dnrtemp.setFullYear(Dnrtemp.getFullYear() - this.DonorAge);
      this.DonorDateOfBirthNew = Dnrtemp;
    }

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
